import React, {useState, useCallback} from 'react';
import Original from 'react-autosuggest';

const getSuggestionValue = (getter) => (value) => value[getter];

const renderSuggestion = (getter) => (value) => {
  let temp = value[getter];
  return <div>{temp}</div>;
};

const Autosuggest = ({suggestions, map, onChangeText, onBlur, error, value = '', label, placeholder}) => {
  const [v, setValue] = useState(value);
  const [s, setSuggestions] = useState([]);

  const getSuggestions = useCallback(
    (v = '') => {
      const temp = v.toString().trim().toLowerCase();
      return temp.length !== 0 ? suggestions.filter((value) => value[map.name].toLowerCase().includes(temp)) : [];
    },
    [suggestions, map.name],
  );

  const onChange = useCallback(
    (_, {newValue}) => {
      setValue(newValue);
      const temp = suggestions.find((value) => value[map.name].toLowerCase() === newValue.toLowerCase()) ?? {};
      onChangeText && onChangeText(temp[map.id] ?? -1);
    },
    [onChangeText, suggestions, map],
  );

  const onSuggestionsFetchRequested = useCallback(
    ({value: temp}) => {
      setSuggestions(getSuggestions(temp));
    },
    [getSuggestions],
  );

  const onSuggestionsClearRequested = useCallback(() => {
    setSuggestions([]);
  }, []);

  return (
    <div>
      {label && <div className=" py-1 label">{label}</div>}
      <Original
        suggestions={s}
        focusInputOnSuggestionClick={false}
        inputProps={{value: v, onBlur, onChange, placeholder, tabIndex: '-1'}}
        renderSuggestion={renderSuggestion(map.name)}
        getSuggestionValue={getSuggestionValue(map.name)}
        onSuggestionsClearRequested={onSuggestionsClearRequested}
        onSuggestionsFetchRequested={onSuggestionsFetchRequested}
        theme={{
          input: 'autosuggest-input',
          container: 'autosuggest',
          suggestionFocused: 'active',
          suggestion: 'react-autosuggest__suggestion',
          inputOpen: 'react-autosuggest__input--open',
          suggestionsContainer: 'react-autosuggest__suggestions-container',
          suggestionsContainerOpen: 'react-autosuggest__suggestions-container--open',
          suggestionsList: `react-autosuggest__suggestions-list ${s.length ? 'show' : ''}`,
        }}
      />
      {error && <small className="text-danger">{error}</small>}
    </div>
  );
};

export default React.memo(Autosuggest);
